import { CUSTOMER_DETAILS_UPDATED, CUSTOMER_DETAILS_READY } from './actions';

export function customerDetailsReducer(state = null, action) {
  switch (action.type) {
    case CUSTOMER_DETAILS_UPDATED:
      return action.details;
    case CUSTOMER_DETAILS_READY:
      return action.details;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerDetailsService/reducers.js